import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild,
  PLATFORM_ID,
  Inject,
} from '@angular/core';
import {
  ChecklistDetailsCategories,
  ChecklistDetailsCheckPoints,
  ChecklistDetailsFileLinkWithThumbnail,
  ChecklistDetailsFinding,
  ChecklistDetailsFindingTypeOption,
  DealerMediaResponse,
  FeatureFlag,
  FileLinkWithThumbnail,
  MapedChecklistDetailsOrder,
  VehicleHealthChecklestResponse,
} from '../services/client.service';
import { ActivatedRoute } from '@angular/router';
import { catchError, forkJoin, of } from 'rxjs';
import { AppService } from '../services/app.service';
import { isPlatformBrowser } from '@angular/common';
import { VideoPlayerService } from '../services/video-player.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { VideoPlayerComponent } from '../video-player/video-player.component';
import { CarouselComponent } from '../carousel/carousel.component';
import { MatDialogModule } from '@angular/material/dialog';
import {
  ButtonModule,
  IconModule,
  StructuredListModule,
  TilesModule,
} from 'carbon-components-angular';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeatureFlagService } from '../services/feature-flag.service';

@Component({
  selector: 'app-vehicle-walkthrough',
  templateUrl: './vehicle-walkthrough.component.html',
  styleUrls: ['./vehicle-walkthrough.component.scss'],
  standalone: true,
  imports: [
    MatExpansionModule,
    MatIconModule,
    VideoPlayerComponent,
    CarouselComponent,
    MatDialogModule,
    MatCardModule,
    TilesModule,
    NgxExtendedPdfViewerModule,
    MatTabsModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatMenuModule,
    MatTooltipModule,
  ],
})
export class VehicleWalkthroughComponent implements OnInit {
  reportResponse!: VehicleHealthChecklestResponse;
  token: string = '';
  @ViewChild('imageModal') imageModal: any;
  modalImageUrl: string | undefined;
  modalImageAlt: string | undefined;
  modelMedia!: FileLinkWithThumbnail[];
  correntSellectedModel: number = 0;
  mediaElememt: string = '';
  @ViewChild('modelVideo') modelVideo!: ElementRef<HTMLVideoElement>;
  isWalkthroughEnabled: boolean = false;
  introOutroMediaData!: DealerMediaResponse;
  @Input() categories: ChecklistDetailsCategories[] = [];
  isDealerBrandingEnabled: boolean = false;
  featureName: string = "Dealer Branding";
  resultSet: FeatureFlag[] = [];

  constructor(
    public appService: AppService,
    private route: ActivatedRoute,
    private videoPlayerService: VideoPlayerService,
    private flagService: FeatureFlagService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.route.queryParams.subscribe((params) => {
        this.token = params['token'];

        forkJoin({
          vhcReport: this.appService.getHealthCheckReport(this.token),
          siteSetting: this.appService.getStyleSettings(this.token),
          dealerMedia: this.appService.getDealerMediaResponse(this.token).pipe(
            catchError((error) => {
              this.appService.handleErrorMessage(error);
              return of(null);
            })
          ),
        }).subscribe({
          next: (response: any) => {
            this.introOutroMediaData = response.dealerMedia;
            this.reportResponse = response.vhcReport;
            if (this.reportResponse.urgentRequired) {
              this.modifyChecklistDetailsResponse(
                this.reportResponse.urgentRequired
              );
            }
          },
        });
      });
    }
    this.emitFeatureFlagStatus();
  }

  closeMediaPlayerModal() {
    this.videoPlayerService.clearActivePlayer();
    if (this.modelVideo) {
      this.modelVideo.nativeElement.pause();
    }
    this.modalImageUrl = '';
    this.imageModal.nativeElement.style.display = 'none';
    document.querySelector('.backdrop')?.setAttribute('style', 'display:none');
  }

  emitFeatureFlagStatus() {
    if (this.featureName && this.flagService.resultSet?.length) {
      const isEnabled = this.flagService.isFeatureEnabled(this.featureName, this.flagService.resultSet);
      this.isDealerBrandingEnabled = isEnabled;
    } 
  }
  
  openMediaPlayerModal(
    media: ChecklistDetailsFileLinkWithThumbnail[] | any,
    position: number,
    isWalkthroughEnabled: boolean | undefined = this.isWalkthroughEnabled
  ) {
    this.isWalkthroughEnabled = isWalkthroughEnabled;
    this.modalImageUrl = '';
    if (this.modelVideo) {
      this.modelVideo.nativeElement.load();
    }
    this.modelMedia = media;
    if (position < 0) {
      position = 0;
    }
    if (position >= media.length) {
      position = media.length - 1;
    }
    if (media) {
      this.correntSellectedModel = position;
      this.modalImageUrl = media[position]?.url;
      this.imageModal.nativeElement.style.display = 'block';
      document
        .querySelector('.backdrop')
        ?.setAttribute('style', 'display:block');
    }
    this.mediaElememt = media[position].mimeType.includes('video')
      ? 'video'
      : 'image';
  }

  isObjectEmpty(obj: any): boolean {
    return obj ? Object.keys(obj).length === 0 : true;
  }

  modifyChecklistDetailsResponse(checklistDetails: MapedChecklistDetailsOrder) {
    if (!checklistDetails.categories) return;

    checklistDetails.categories.forEach(
      (category: ChecklistDetailsCategories) => {
        if (!category.checkpoints) return;

        category.checkpoints.forEach(
          (checkpoint: ChecklistDetailsCheckPoints) => {
            if (
              checkpoint.status === 'NotOK' &&
              checkpoint.findings &&
              checkpoint.findingTypeOptions
            ) {
              let hasRedFinding = checkpoint.findings.some(
                (finding: ChecklistDetailsFinding) =>
                  checkpoint?.findingTypeOptions?.some(
                    (option: ChecklistDetailsFindingTypeOption) =>
                      option.id === finding?.findingType?.id &&
                      option.color === 'Red'
                  )
              );

              if (hasRedFinding) {
                checkpoint.status = 'NotOKRed';
              }
            }
          }
        );
      }
    );
  }
}
